// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3dNaq","tab":"Tabs_tab__TsOav","tabActive":"Tabs_tabActive__1oM3W"};